import DisplayPrivatePageRowAction, { DisplayPrivatePageRowActionProps } from './DisplayPrivatePageRowAction';

export function GoPrivatePageRowAction(props: GoPrivatePageRowActionProps) {
    return <DisplayPrivatePageRowAction {...props} />;
}

export type GoPrivatePageRowActionProps = DisplayPrivatePageRowActionProps;

// noinspection JSUnusedGlobalSymbols
export default GoPrivatePageRowAction;
